var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a.square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a.square_2",
    d: "M6.16854 21H17.8315C19.9213 21 21 19.9213 21 17.8604V6.13965C21 4.07865 19.9213 3 17.8315 3H6.16854C4.08828 3 3 4.06902 3 6.13965V17.8604C3 19.9213 4.08828 21 6.16854 21ZM6.29374 19.0835C5.4077 19.0835 4.91653 18.6212 4.91653 17.687V6.313C4.91653 5.37881 5.4077 4.91653 6.29374 4.91653H17.7063C18.5827 4.91653 19.0835 5.37881 19.0835 6.313V17.687C19.0835 18.6212 18.5827 19.0835 17.7063 19.0835H6.29374ZM8.94221 16.4928C9.38523 16.4928 9.67416 16.2713 9.82825 15.7223L10.4157 14.008H13.5939L14.1814 15.7223C14.3355 16.2713 14.6244 16.4928 15.0674 16.4928C15.5875 16.4928 15.9246 16.175 15.9246 15.6838C15.9246 15.5201 15.886 15.3371 15.7994 15.0867L13.3531 8.38363C13.122 7.7191 12.6693 7.38202 11.9952 7.38202C11.3307 7.38202 10.8876 7.70947 10.6469 8.38363L8.21027 15.0867C8.1236 15.3371 8.08507 15.5201 8.08507 15.6742C8.08507 16.175 8.41252 16.4928 8.94221 16.4928ZM10.8202 12.6597L11.9567 9.20225H12.053L13.1894 12.6597H10.8202Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundA);
export default __webpack_public_path__ + "static/media/backgroundA.b0b7175cf05da26c476f0268c19aa84c.svg";
export { ForwardRef as ReactComponent };